<div class="container" *ngIf="!(geolocationService.coords$ | async)">
    <button class="btn-geo" (click)="geolocationService.requestGeolocation()">Active Location</button>
    <p>Activate your location to receive the weather data for your city.</p>
</div>
